var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.3335C10.9204 1.3335 11.6666 2.07969 11.6666 3.00016C11.6666 3.92064 10.9204 4.66683 9.99996 4.66683C9.07949 4.66683 8.33329 3.92064 8.33329 3.00016C8.33329 2.07969 9.07949 1.3335 9.99996 1.3335Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 1.3335C4.25377 1.3335 4.99996 2.07969 4.99996 3.00016C4.99996 3.92064 4.25377 4.66683 3.33329 4.66683C2.41282 4.66683 1.66663 3.92064 1.66663 3.00016C1.66663 2.07969 2.41282 1.3335 3.33329 1.3335Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 1.3335C17.5871 1.3335 18.3333 2.07969 18.3333 3.00016C18.3333 3.92064 17.5871 4.66683 16.6666 4.66683C15.7462 4.66683 15 3.92064 15 3.00016C15 2.07969 15.7462 1.3335 16.6666 1.3335Z",
    stroke: "#00205E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.730aed4b127146b6f44354add25e1c88.svg";
export { ForwardRef as ReactComponent };